import type { SbReportTag } from '@/types'

export const useReportsStore = defineStore('reports', () => {
  const tagStories = ref<SbReportTag[] | null>(null)
  const checkedTags = ref<Record<string, boolean>>({})

  const filters = ref({
    shouldHaveEnglish: false,
    shouldHaveGerman: false,
  })

  const filtersDraft = ref({
    shouldHaveEnglish: false,
    shouldHaveGerman: false,
    tags: {} as Record<string, boolean>,
  })

  const clearFilters = () => {
    filters.value.shouldHaveEnglish = false
    filters.value.shouldHaveGerman = false
    checkedTags.value = {}

    filtersDraft.value.shouldHaveEnglish = false
    filtersDraft.value.shouldHaveGerman = false
    filtersDraft.value.tags = {}
  }

  const checkedTagsArray = computed(() => {
    return Object.keys(checkedTags.value).filter(
      (key) => checkedTags.value[key],
    )
  })

  return {
    filters,
    filtersDraft,
    clearFilters,
    tagStories,
    checkedTags,
    checkedTagsArray,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useReportsStore, import.meta.hot))
}
